module.exports = __webpack_public_path__ + "img/noAnnouncement.8bcc29a7.png";